import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../Errors/InvalidParamsSharedError.js'

const EMPTY_STRING = ''

export class StringSharedValueObject extends ValueObject {
  #value

  static empty() {
    return new StringSharedValueObject({value: EMPTY_STRING})
  }

  static validate({value}) {
    if (typeof value !== 'string') {
      throw InvalidParamsSharedError.create(`[StringSharedValueObject.validate] param(${value}) should be a string`)
    }
  }

  static normalize({value}) {
    return typeof value === 'number' ? `${value}` : value
  }

  static sanitize({config, string}) {
    const noCodeRegex = config.get('REGEX_CODE')
    const decodedString = decodeURIComponent(string)
    const hasInvalidChars = noCodeRegex.test(decodedString)
    return hasInvalidChars ? EMPTY_STRING : decodedString
  }

  static isEmpty({value}) {
    return value === undefined || value === null
  }

  static create({value}) {
    const normalizedString = StringSharedValueObject.normalize({value})
    return new StringSharedValueObject({value: normalizedString})
  }

  static createFromPrimitives({value}) {
    const normalizedString = StringSharedValueObject.normalize({value})
    return new StringSharedValueObject({value: normalizedString})
  }

  static createWithSanitize({config, value}) {
    const normalizedString = StringSharedValueObject.normalize({value})
    const isEmpty = StringSharedValueObject.isEmpty({value})

    return new StringSharedValueObject({
      value: isEmpty ? value : StringSharedValueObject.sanitize({config, string: normalizedString})
    })
  }

  constructor({value}) {
    super()
    this.#value = value
  }

  get value() {
    return this.#value
  }

  isEmpty() {
    return this.#value === EMPTY_STRING
  }

  // Legacy method, please use toPrimitives instead
  toJSON() {
    return {value: this.#value}
  }

  toPrimitives() {
    return {value: this.#value}
  }
}
